import { createSelector } from 'reselect'
import { identity } from 'ramda'
import { getIn } from 'utils/immutable'

const isDrawerVisibleSelector = getIn(['drawer', 'isDrawerVisible'])
const showDrawerMaskSelector = getIn(['drawer', 'showDrawerMask'])
const drawerWidthSelector = getIn(['drawer', 'drawerWidth'])
const drawerVisibleWidthSelector = getIn(['drawer', 'visibleWidth'])
const isDrawerOpenedSelector = getIn(['drawer', 'isDrawerOpened'])

export const getIsDrawerVisible = createSelector(
  isDrawerVisibleSelector,
  identity
)

export const getShowDrawerMask = createSelector(
  showDrawerMaskSelector,
  identity
)

export const getDrawerWidth = createSelector(drawerWidthSelector, identity)
export const getDrawerVisibleWidth = createSelector(
  drawerVisibleWidthSelector,
  identity
)

export const getIsDrawerOpened = createSelector(
  isDrawerOpenedSelector,
  identity
)
